var render = function render(){var _vm=this,_c=_vm._self._c;return _c('config-provider',{attrs:{"locale":_vm.currentLocale,"renderEmpty":_vm.renderEmpty}},[_c('router-view',{key:_vm.userId,class:_vm.$style.root})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }